module.exports = __webpack_public_path__ + "img/expand_more_black_24dp.7e50370f.svg";